export class Model_CRM_SourceOf_Query {

    public SourceQuery: string;
    public SourceQueryId: number;

}
